<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="Label pola"
			aria-label="label"
			for="checkbox-props-label"
			id="checkbox-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="hint"
			aria-label="hint"
			for="checkbox-props-hint"
			id="checkbox-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-checkbox v-model="fieldProps.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>
</template>

<script>
	export default {
		name: "checkboxProps",

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
		},

		props: {
			value: Object,
		},

		data() {
			return {
				fieldProps: this.value,
			};
		},
	};
</script>

<style scoped>

</style>
